import crm from './crm';

const equipeService = {
	index:()=>{
		return crm.get('/usuarios');
	},
};

export default equipeService;